
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#3A4249","d":"M19 31V2h12.586c.905 0 1.774.359 2.414 1 .64.641 1.509 1 2.414 1H45v27H19zM2 42v16a4 4 0 004 4h52a4 4 0 004-4V42H2zm30 14c-4.418 0-8-2.238-8-5s3.582-5 8-5 8 2.238 8 5-3.582 5-8 5zm19-10h-2v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2z"}}),_c('path',{attrs:{"fill":"#3A4249","d":"M52 21h-5v6a2 2 0 012 2v2a2 2 0 01-2 2H17a2 2 0 01-2-2v-2a2 2 0 012-2v-6h-5L2 40h60L52 21z"}})])
          )
        }
      }
    